var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPulse = function SvgPulse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12a.75.75 0 0 1-.75.75h-2.537l-3.542 7.086a.75.75 0 0 1-.671.414h-.037a.75.75 0 0 1-.664-.482L8.939 5.696 5.933 12.31a.75.75 0 0 1-.683.44h-3a.75.75 0 1 1 0-1.5h2.517l3.55-7.81a.75.75 0 0 1 1.384.043l5.392 14.156 2.986-5.973a.75.75 0 0 1 .671-.416h3a.75.75 0 0 1 .75.75"
  })));
};
export default SvgPulse;